import { PhoneInput } from '@/schemas/sceneDataSchema';
import { UseFormReturn } from 'react-hook-form';
import { GenericInput } from './GenericInput';

export const InputPhoneFormElement = ({ form, component }: { form: UseFormReturn; component: PhoneInput }) => {
  return (
    <GenericInput
      form={form}
      component={component}
      type='tel'
    />
  );
};
